import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledPrintsForm = styled(StyledFlex)`
   margin-top: 1px;
`;
